import { render } from "./MakeupControlCard.vue?vue&type=template&id=08501f28&ts=true"
import script from "./MakeupControlCard.vue?vue&type=script&lang=ts"
export * from "./MakeupControlCard.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src835202786/src/web-previewer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__